const capitalizeWords = (str, lower = true) => {
	if (!str) return ''
	return (lower ? str.toLowerCase() : str).replace(
		/(?:^|\s|["'([{])+\S/g,
		(match) => match.toUpperCase()
	)
}

export default capitalizeWords
